import * as _ from 'lodash';
import * as React from 'react';
import CSSTransition from 'react-transition-group/CSSTransition';
import TransitionGroup from 'react-transition-group/TransitionGroup';

import * as transitionStyles from './transitionStyles';

namespace TransitioningFields {
  export interface FieldConfig {
    key: React.Key;
    style: transitionStyles.TransitionStyle;
    in?: boolean;
    component: React.ReactNode;
  }

  export interface Props {
    fields: FieldConfig[];
  }
}

class TransitioningFields extends React.Component<TransitioningFields.Props> {
  render() {
    const { fields } = this.props;

    return (
      <TransitionGroup>
        {_.map(fields, field => {
          // must be the actual false boolean - can't be undefined or null
          if (field.in === false) return;
          return (
            <CSSTransition
              key={field.key}
              data-it={field.key}
              timeout={transitionStyles.CSSTransitionTimeout}
              classNames={transitionStyles.classNameConfigs[field.style]}
            >
              {
                // We need to wrap actual content in a div; when we apply max-height directly to the child,
                // the transition won't account for any margin, padding, or border the child has, which will lead to
                // choppy transitions. Applying it to the wrapping div instead smooths out these issues
              }
              <div>{field.component}</div>
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    );
  }
}

export default TransitioningFields;
